// extracted by mini-css-extract-plugin
export var active = "_2i-j";
export var cell = "_2i-3";
export var cellLoading = "_2i-6";
export var center = "_2i-10";
export var clickable = "_2i-c";
export var compact = "_2i-4";
export var container = "_2i-8";
export var data = "_2i-a";
export var dataRow = "_2i-b";
export var dateRangeContainer = "_2i-2";
export var downloadIcon = "_2i-v";
export var empty = "_2i-e";
export var filter = "_2i-g";
export var filterContainer = "_2i-16";
export var filterCount = "_2i-i";
export var filterLabel = "_2i-h";
export var filters = "_2i-f";
export var header = "_2i-l";
export var headerButton = "_2i-m";
export var headerContent = "_2i-n";
export var headerLabel = "_2i-p";
export var headerRow = "_2i-u";
export var headerSort = "_2i-o";
export var headerSortAsc = "_2i-r";
export var headerSortContainer = "_2i-q";
export var headerSortDesc = "_2i-s";
export var headerSpacer = "_2i-t";
export var headers = "_2i-w";
export var infoIcon = "_2i-1b";
export var left = "_2i-z";
export var loader = "_2i-y";
export var loaderContainer = "_2i-x";
export var main = "_2i-9";
export var movingGradient = "_2i-7";
export var options = "_2i-0";
export var pageChangeButton = "_2i-1a";
export var pageControl = "_2i-17";
export var pageControlSticky = "_2i-18";
export var pageNumbers = "_2i-19";
export var right = "_2i-11";
export var seamless = "_2i-1";
export var spacer = "_2i-12";
export var table = "_2i-14";
export var tableContainer = "_2i-13";
export var tableFitToParent = "_2i-15";
export var textHeader = "_2i-k";
export var title = "_2i-d";
export var wide = "_2i-5";